import { NonEmptyString, OptionalNonEmptyString } from 'helper/zod';
import { z } from 'zod';

export const EnvSchema = z.looseObject({
    DEV_SERVER_PORT: OptionalNonEmptyString(),
    PORT: OptionalNonEmptyString(),
    VITE_AUTH_IDENTITY_POOL_ID: NonEmptyString(),
    VITE_AUTH_USER_POOL_CLIENT_ID: NonEmptyString(),
    VITE_AUTH_USER_POOL_ID: NonEmptyString(),
    VITE_ENABLE_MOCK_SERVER: OptionalNonEmptyString(),
    VITE_GRAPHQL_ENDPOINT: NonEmptyString(),
    VITE_VEHICLE_SERVICE_ENDPOINT: NonEmptyString(),
    VITE_MISSION_HUB_SERVICE_ENDPOINT: NonEmptyString(),
    VITE_MONITORING_SERVICE_ENDPOINT: NonEmptyString(),
    VITE_MANAGEMENT_SERVICE_ENDPOINT: NonEmptyString(),
    VITE_HOME_ROUTE: NonEmptyString(),
    VITE_SIMULATION_ROUTE: NonEmptyString(),
    VITE_ENV_CONFIG: NonEmptyString(),
    VITE_TEAM_IDENTIFIER: NonEmptyString(),
    VITE_ACCOUNT_ID: NonEmptyString(),
    VITE_MAP_SERVICE_API_KEY: NonEmptyString(),
    VITE_HERE_REVERSE_GEOCODE_BASE_URL: NonEmptyString(),
    VITE_DATADOG_SITE: NonEmptyString(),
    VITE_DATADOG_CLIENT_TOKEN: NonEmptyString(),
});

export type EnvConfig = z.infer<typeof EnvSchema>;
